import Vue from 'vue'
import Router from 'vue-router'
import startpage from '@/components/startpage'
import startpage2 from '@/components/startpage2'

import enheter from '@/components/enheter'
import enhet from '@/components/enhet'

import schemalaggningar from '@/components/schemalaggningar'
import schemalaggningar_ny from '@/components/schemalaggningar_ny'

import rum from '@/components/rum'
import rum_nytt from '@/components/rum_nytt'
import rum_detaljer from '@/components/rum_detaljer'

import add from '@/components/add'
import add_virtuell from '@/components/add_virtuell'
import add_systemnexa from '@/components/add_systemnexa'
import add_nxt from '@/components/add_nxt'
import add_zwave from '@/components/add_enhet_zwave'
import add_firesafety from '@/components/add_firesafety'
import zwave_exclude from '@/components/zwave_exclude'

import installningar from '@/components/installningar'

import aktivitetslogg from '@/components/aktivitetslogg'

import save_device from '@/components/save_device'

import scenarion from '@/components/scenarion'
import scenarion_ny from '@/components/scenarion_ny'

import automationer from '@/components/automationer'
import automationer_ny from '@/components/automationer_ny'
import automationer_ny2 from '@/components/dev_automationer_ny'

import grafer from '@/components/grafer'
import resetpass from '@/components/resetpass'
import cancel_offline_email from '@/components/cancel-offline-email'

import energimatning from '@/components/energimatning'

import nu from '@/components/nu'

Vue.use(Router)

export default new Router({
  routes: [
    /** startsidan */
    { path: '/', name: 'startpage', component: startpage, meta: { color:'#fcd574' } },
    
    /** enheter */
    { path: '/enheter', name: 'enheter', component: enheter, meta: { title: 'enheter', color:'#749afc' } },
    { path: '/enheter/ny', name: 'nyenhet', component: add, meta: { title: 'lägg till enhet', color:'#749afc' } },
    { path: '/enheter/:id', name: 'enhet', component: enhet, meta: { color:'#749afc' } },
    { path: '/enheter/:id/edit', name: 'spara_enhet', component: save_device, meta: { color:'#749afc' } },
    { path: '/enheter/ny/virtuell', name: 'add_virtuell', component: add_virtuell, meta: { title: 'lägg till virtuell enhet', color:'#fcd574' } },
    { path: '/enheter/ny/systemnexa', name: 'add_systemnexa', component: add_systemnexa, meta: { title: 'lägg till system nexa', color:'#749afc' } },
    { path: '/enheter/ny/nxt', name: 'add_nxt', component: add_nxt, meta: { title: 'lägg till NXT', color:'#749afc' } },
    { path: '/enheter/ny/zwave', name: 'add_zwave', component: add_zwave, meta: { title: 'lägg till zwave', color:'#749afc' } },
    { path: '/enheter/ny/firesafety', name: 'add_firesafety', component: add_firesafety, meta: { title: 'lägg till fire & safety', color:'#749afc' } },
    { path: '/enheter/radera/zwave', name: 'remove_zwave', component: zwave_exclude, meta: { title: 'exkludera zwave', color:'#749afc' } },
    { path: '/enheter/save', name: 'save_node', component: save_device, meta: { title: 'spara', color:'#749afc' } },

    /** schemaläggningar */
    { path: '/schemalaggningar', name: 'schemalaggningar', component: schemalaggningar, meta: { title: 'schemaläggningar' } },
    { path: '/schemalaggningar/ny', name: 'schemalaggningar_ny', component: schemalaggningar_ny, meta: { title: 'schemaläggningar' } },
    { path: '/schemalaggningar/:id', name: 'schemalaggningar_edit', component: schemalaggningar_ny, meta: { title: 'schemaläggningar' } },

    /** rum **/
    { path: '/rum', name: 'rum', component: rum, meta: { title: 'dina rum', color:'#e374fc' } },
    { path: '/rum/ny', name: 'rum_ny', component: rum_nytt, meta: { title: 'skapa rum', color:'#e374fc' } }, 
    { path: '/rum/:id', name: 'rum_detaljer', component: rum_detaljer, meta: { title:'detaljer', color:'#e374fc' } },
    { path: '/rum/:id/edit', name: 'rum_edit', component: rum_nytt, meta: { title:'detaljer', color:'#e374fc' } },

    /** automationer **/
    { path: '/automationer', name: 'automationer', component: automationer, meta: { title: 'automationer', color:'#fcc774' } },
    { path: '/automationer/ny', name: 'automationer_ny', component: automationer_ny, meta: { title: 'skapa automation', color:'#fcc774' } },
    { path: '/automationer/ny2', name: 'automationer_ny2', component: automationer_ny2, meta: { title: 'skapa automation', color:'#fcc774' } },
    { path: '/automationer/:id', name: 'automationer_edit', component: automationer_ny, meta: { title: 'editera automation', color:'#fcc774' } },

    /** scenarion **/
    { path: '/scenarion', name: 'scenarion', component: scenarion, meta: { title: 'scenarion', color:'#749afc' } },
    { path: '/scenarion/ny', name: 'scenarion_ny', component: scenarion_ny, meta: { title: 'skapa scenario', color:'#749afc' } },
    { path: '/scenarion/:id', name: 'scenarion_edit', component: scenarion_ny, meta: { title: 'redigera scenario', color:'#749afc' } },
    
    /** övrigt **/
    { path: '/installningar', name: 'installningar', component: installningar, meta: { title: 'inställningar', color:'#fcc774' } },
    { path: '/installningar/wifi', name: 'installningar_wifi', component: installningar, meta: { title: 'inställningar', color:'#fcc774' } },
    
    /** grafer */
    { path: '/grafer', name: 'grafer', component: grafer, meta: { title: 'inställningar', color:'#fcc774' } },
    
    /** aktivitetslogg */
    { path: '/aktivitetslogg', name: 'aktivitetslogg', component: aktivitetslogg, meta: { title: 'aktivitetslogg', color:'#fcc774' } },
    
    /** återställ lösenord */
    { path: '/resetpass', name: 'resetpass', component: resetpass, meta: { title: 'resetpass', color:'#fcc774' } },
    { path: '/resetpass/:code', name: 'resetpass_code', component: resetpass, meta: { title: 'resetpass', color:'#fcc774' } },

    { path: '/offline/:uid', name: 'cancel_offline_email', component: cancel_offline_email, meta: { title: 'cancel_offline_email', color:'#fcc774' } },

    /** nu **/
    { path: '/nu', name: 'nu', component: nu, meta: { title: 'nu', color:'#fcc774' } },
    { path: '/energimatning', name: 'energimätning', component: energimatning, meta: { title: 'energimätning', color:'#fcc774' } },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js